import { guideRowHtml } from "./component.js";
const scalarRow = {
  name: "scalar-row",
  tagName: "scalar-row",
  tiptapName: "scalar-row",
  attributeTransform: (_, _attrs) => {
    return {
      classes: ""
    };
  },
  render: async (props) => {
    const transformed = scalarRow.attributeTransform("", props);
    return transformed ? guideRowHtml(transformed) : "";
  }
};
export {
  scalarRow
};
//# sourceMappingURL=index.js.map
